import React, { useState, useEffect } from "react";
import { reduxForm, Field, initialize } from "redux-form";
import {
  Grid,
  Header,
  Button,
  Label,
  Radio,
  FormField,
  Modal,
} from "semantic-ui-react";
import {
  renderTextField,
  renderOptionField,
  renderRadioField,
} from "../formcomponents";
import axios from "axios";
import { BaseUrlInvoice, BaseUrl } from "../formcomponents/Constants";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { userData } from "../store/userData";
import UploadeExcelData from "./UploadeExcelData";
import UploadManualData from "./UploadManualData";

const CreateTicketLiatData = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();

  const { id, catId } = useParams();
  const userDectail = userData();
  const [currentData, setCurrentData] = useState();
  const [fieldDisable, setfieldDisable] = useState(false);
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [uploadExcel, setUploadExcel] = useState("true");
  const [showConfirmationPopUp, setshowConfirmationPopUp] = useState(false);
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (id != "null") {
      getVisaDetail();
    } else {
      //2023-09-26
    }
    if (userDectail.userRole != 1 && id != "null") {
      setfieldDisable(true);
    }
    getWorkCatList();
    getticketCatogery();

    const tempData = {
      categoryId: Number(catId),
    };

    initializeData(tempData);
  }, [id, catId]);

  const [ticketTypeList, setTicketTypeList] = useState([]);
  const [workCategory, setworkCategory] = useState([]);

  const getWorkCatList = () => {
    axios
      .post(BaseUrl + "/listSSVisaCategory", {
        ssVisaId: "",
        visaTypeNumber: 45,
      })
      .then((res) => {
        console.log("res", res.data);
        const ticketDataObject = res.data.map((item) => ({
          text: item.visaCategory,
          value: item.visaCategoryId,
        }));

        const sortedData = ticketDataObject.sort((a, b) => {
          return a.text?.localeCompare(b.text);
        });

        console.log("res", sortedData);
        setTicketTypeList(sortedData);
      })
      .catch((error) => console.log(error));
  };

  const getticketCatogery = () => {
    axios
      .post(BaseUrl + "/listSSVisaCategory", {
        ssVisaId: "",
        visaTypeNumber: 35,
      })
      .then((res) => {
        console.log("Original data:", res.data);
        const sortedData = res.data.sort((a, b) => {
          console.log("Comparing:", a.visaCategory, b.visaCategory);
          return a.visaCategory?.localeCompare(b.visaCategory);
        });

        const ticketDataObject = sortedData.map((item) => ({
          text: item.visaCategory,
          value: item.visaCategoryId,
        }));

        console.log("Sorted data:", sortedData);
        setworkCategory(ticketDataObject);
      })
      .catch((error) => console.log(error));
  };

  const getVisaDetail = () => {
    axios
      .post(BaseUrlInvoice + "accounts/getInventoryDetail", {
        userId: userDectail.userId,
        ssInventoryId: id,
        categoryId: catId,
        getAll: catId == 0 ? true : false,
      })
      .then((res) => {
        console.log(res.data);
        console.log(id);
        const tempData = res.data;
        //setrowData(res.data);
        //setDataForExcel(res.data);
        setCurrentData(res.data);
        console.log(JSON.stringify("our data------->", null, 2));
        console.log(JSON.stringify(tempData, null, 2));
        initializeData(tempData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const initializeData = (data) => {
    props.initialize({
      ...data,
    });
  };

  const sumbitForm = (values) => {
    ///visa/createSSVisa

    const postObject = {
      ...values,

      userId: userDectail.userId,
    };

    console.log(`You Values:\n\n${JSON.stringify(postObject, null, 2)}`);
    axios
      .post(BaseUrlInvoice + "accounts/createInventory", postObject)
      .then((res) => {
        console.log(res.data);
        setshowConfirmationPopUp(false);
        Swal.fire("Success", "Data Added", "success");
        if (id != "null") {
          navigate(`/list-ticket-data-all/${res.data.categoryId}`);
        }
        // navigate(`/list-ticket-data-all/${res.data.categoryId}`);
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(values);
  };

  const handleConfirm = () => {
    setshowConfirmationPopUp(false);
    // Call submitForm or any other action
  };

  const handleCancel = () => {
    setshowConfirmationPopUp(false);
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Create Ticket Data one
        </Header>
      </Grid.Row>
      <br />
      <Grid.Row>
        <Grid columns="six">
          <Grid.Row>
            <Field
              name="categoryId"
              label="Category"
              options={workCategory}
              component={renderOptionField}
            />

            <Grid.Column>
              <Field
                name="ticketType"
                label="Ticket Type"
                options={ticketTypeList}
                component={renderOptionField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="purchaseDate"
                label="Purchase Date"
                type="date"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="expiryDate"
                label="Expiry Date"
                type="date"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              {/* <Field
                name="applicationNumber"
                label="Application Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              /> */}
              <Field
                name="invoiceNo"
                label="Invoice Number"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="remarks"
                label="Remarks"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="four">
          <Grid.Row>
            <Grid.Column>
              <div
                style={{
                  flex: "row",
                }}
              >
                <h2>Total Upload</h2> <h2>{currentData?.uploadedTotal}</h2>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  flex: "row",
                }}
              >
                <h2>Total Available</h2> <h2>{currentData?.availableTicket}</h2>
              </div>
            </Grid.Column>
            <Grid.Column>
              <Field
                name="b2bPrice"
                label="B2B Price"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>{" "}
            <Grid.Column>
              <Field
                name="b2cPrice"
                label="B2C Price"
                type="text"
                disabled={fieldDisable === true && "true"}
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <br />
      <Button
        floated="right"
        positive
        disabled={submitting}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        // disabled={pristine || submitting}
        onClick={() => navigate(`/list-ticket-data-all/null`)}
      >
        Go To List
      </Button>{" "}
      <br /> <br />
      <div
        style={{
          border: "1px solid #0033FF", // Adding a black border with 1px width
          backgroundColor: "#C4CBFF", // Adding a light gray background color
          padding: "10px", // Adding some padding for better appearance
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <FormField>
            <Radio
              label="Uplaod Excel"
              name="uploadFileType"
              value="true"
              checked={uploadExcel === "true"}
              onChange={() => setUploadExcel("true")}
            />
          </FormField>{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <FormField>
            <Radio
              label="Generate BarCode"
              name="uploadFileType"
              value="false"
              checked={uploadExcel === "false"}
              onChange={() => setUploadExcel("false")}
            />
          </FormField>
        </div>
        <br /> <br />
        {uploadExcel === "true" ? (
          <Field
            name="ticketList"
            label="Uplad Excel"
            type="text"
            ticketList={currentData?.ticketList}
            disabled={fieldDisable === true && "true"}
            component={UploadeExcelData}
            triggerParentMethod={() => setshowConfirmationPopUp(true)}
          />
        ) : (
          <Field
            name="ticketList"
            label="Uplad Excel"
            type="text"
            ticketList={currentData?.ticketList}
            disabled={fieldDisable === true && "true"}
            component={UploadManualData}
          />
        )}
      </div>
      <br />
      <Modal open={showConfirmationPopUp} onClose={handleCancel} size="small">
        <Modal.Header>Confirmation</Modal.Header>
        <Modal.Content>
          <p>Please save your changes before leaving the page.</p>
        </Modal.Content>
        <Modal.Actions>
          {/* <Button negative onClick={handleCancel}>
            No
          </Button> */}
          <Button
            positive
            onClick={handleSubmit((values) =>
              sumbitForm({
                ...values,
              })
            )}
          >
            Yes
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default reduxForm({
  form: "CreateTicketLiatData",
  // validate,
})(CreateTicketLiatData);
